<!-- 调度入园审批界面 -->
<template>
  <div class="access-record-container">
    <!--主页面 -->
    <div class="flex-row" style="height: 100%">
      <div class="flex-auto flex-valign" style="overflow: hidden">
        <!-- 右侧表格 -->
        <div class="section-main_table" style="flex-direction: column">
          <!-- 查询条件 -->
          <div class="query">
            <el-form
              style="margin-top: 10px; transition: all 200ms"
              :class="showSearch ? 'expand searchContent' : 'up searchContent'"
              :inline="true"
              ref="search-form"
              label-position="right"
              label-width="90px"
              :model="searchForm"
            >
              <el-form-item label="预约园区">
                <el-select
                  v-model="searchForm.appointmentPark"
                  placeholder="请选择"
                  style="width: 200px"
                >
                  <el-option
                    v-for="item in parkOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>

              <el-form-item label="司机姓名">
                <el-input
                  v-model="searchForm.driverName"
                  style="width: 200px"
                ></el-input>
              </el-form-item>
              <el-form-item label="前车车牌">
                <el-input
                  v-model="searchForm.frontPlate"
                  style="width: 200px"
                />
              </el-form-item>
              <el-form-item label="柜号">
                <el-input v-model="searchForm.cabinetNo" style="width: 200px" />
              </el-form-item>
              <el-form-item label="手机号">
                <el-input v-model="searchForm.phone" style="width: 200px" />
              </el-form-item>
              <!-- <el-form-item label="审批状态">
                <el-checkbox-group
                  v-model="searchForm.appointmentStatus"
                  style="width: 200px"
                >
                  <el-checkbox
                    v-for="(v, index) in appointmentStatusList"
                    :key="index"
                    :label="v.value"
                    >{{ v.label }}
                  </el-checkbox>
                </el-checkbox-group>
              </el-form-item> -->
              <el-form-item label="作业类型">
                <el-select
                  multiple
                  v-model="selectedType"
                  placeholder="请选择"
                  style="width: 200px"
                >
                  <el-option
                    v-for="item in zyTypeOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>

              <!-- <div> -->
              <el-form-item label="操作类型" v-if="selectedType.includes('3')">
                <el-select
                  multiple
                  v-model="selectedOperateType"
                  placeholder="请选择"
                  style="width: 200px"
                >
                  <el-option
                    v-for="item in czTypeOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="预约日期">
                <el-date-picker
                  type="daterange"
                  value-format="yyyy-MM-dd"
                  start-placeholder="选择预约开始日期"
                  end-placeholder="选择预约结束日期"
                  v-model="dateRange"
                  style="width: 300px"
                ></el-date-picker>
              </el-form-item>
              <!-- </div> -->
            </el-form>

            <div>
              <el-button type="primary" @click="searchResult"
                >{{ $t("accountGroup.button.query") }}
              </el-button>
              <el-button type="info" @click="resetQuery"
                >{{ $t("accountGroup.button.reset") }}
              </el-button>
              <el-button
                type="text"
                size="medium"
                v-show="showExpandBtn"
                style="color: #407aee"
                @click="showSearch = !showSearch"
                :icon="showSearch ? 'el-icon-arrow-up ' : 'el-icon-arrow-down'"
                >{{ !showSearch ? "展开" : "收起" }}
              </el-button>
            </div>
          </div>

          <!-- 审核状态 -->
          <div class="appoint-approval-status-box">
            <div
              :class="[
                'approval-status-btn',
                activeStatusIndex === index ? 'active' : '',
              ]"
              v-for="(item, index) in selectStatusList"
              :key="index"
              @click="handleStatusTabClick(index)"
            >
              {{ item }}
            </div>
          </div>
          <div
            v-if="activeStatusIndex == 0"
            class="appoint-approval-content-box"
          >
            <ioc-table
              ref="unApprovalTab"
              :data="unApprovalTableData"
              :option="unApprovalTableOption"
              :page="unApprovalPage"
              @row-cancle="closeDialog"
              @current-change="selectUnApprovalPage"
              @size-change="changeUnApprovalSize"
              @selection-change="handleSelectionChange"
            >
              <!-- 状态 -->
              <!-- <template slot="workflow" slot-scope="scope">
                <span>{{ showNameByStatus(scope.row.workflow.status) }}</span>
              </template> -->
              <template slot="menu" slot-scope="scope">
                <el-tooltip
                  class="item"
                  effect="dark"
                  content="详情"
                  placement="top"
                  popper-class="tooltip-draw"
                  style="font-size: 18px"
                >
                  <el-button
                    type="text"
                    icon="el-icon-view"
                    @click="handleView(scope.row, scope.index)"
                  ></el-button>
                </el-tooltip>
                <el-tooltip
                  v-if="scope.row.appointmentStatus == 1"
                  class="item"
                  effect="dark"
                  content="通过"
                  placement="top"
                  popper-class="tooltip-draw"
                  style="font-size: 18px"
                >
                  <el-button
                    type="text"
                    icon="el-icon-circle-check"
                    @click="handelPassSingleAppoint(scope.row)"
                  ></el-button>
                </el-tooltip>
                <el-tooltip
                  v-if="scope.row.appointmentStatus == 1"
                  class="item"
                  effect="dark"
                  content="拒绝"
                  placement="top"
                  popper-class="tooltip-draw"
                  style="font-size: 18px"
                >
                  <el-button
                    type="text"
                    icon="el-icon-circle-close"
                    @click="handelRejectSingleAppoint(scope.row)"
                  ></el-button>
                </el-tooltip>
              </template>
            </ioc-table>
          </div>
          <div v-else class="appoint-approval-content-box">
            <ioc-table
              ref="approvalDoneTable"
              height="60%"
              :data="approvalDoneTableData"
              :option="approvalDoneTableOption"
              :page="approvalDonePage"
              @row-cancle="closeDialog"
              @current-change="selectApprovalDonePage"
              @size-change="changeApprovalDoneSize"
              @selection-change="handleSelectionChange"
            >
              <!-- 状态 -->
              <!-- <template slot="workflow" slot-scope="scope">
                <span>{{ showNameByStatus(scope.row.workflow.status) }}</span>
              </template> -->
              <template slot="menu" slot-scope="scope">
                <el-tooltip
                  class="item"
                  effect="dark"
                  content="详情"
                  placement="top"
                  popper-class="tooltip-draw"
                  style="font-size: 18px"
                >
                  <el-button
                    type="text"
                    icon="el-icon-view"
                    @click="handleView(scope.row, scope.index)"
                  ></el-button>
                </el-tooltip>
              </template>
            </ioc-table>
          </div>
        </div>
      </div>
    </div>
    <!--详情-->
    <appPanel
      :width="750"
      class="app-panel"
      :isExpand="showPanel"
      @cancel="handleClosePanel"
      title="调度预约详情"
    >
      <h3>基础信息</h3>
      <div class="panel-content">
        <el-card style="margin: 15px 20px 15px 10px">
          <el-form
            :inline="true"
            :model="approvalDetailInfo"
            label-width="110px"
            label-position="right"
            label-suffix=" :"
          >
            <el-row>
              <el-col :span="12">
                <el-form-item label="司机姓名">{{
                  approvalDetailInfo.driverName
                    ? approvalDetailInfo.driverName
                    : "暂无"
                }}</el-form-item></el-col
              >
              <el-col :span="12">
                <el-form-item label="手机号">{{
                  approvalDetailInfo.phone ? approvalDetailInfo.phone : "暂无"
                }}</el-form-item></el-col
              >
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="客户名称">{{
                  approvalDetailInfo.custom ? approvalDetailInfo.custom : "暂无"
                }}</el-form-item></el-col
              >
              <el-col :span="12">
                <el-form-item label="前车车牌">{{
                  approvalDetailInfo.frontPlate
                    ? approvalDetailInfo.frontPlate
                    : "暂无"
                }}</el-form-item></el-col
              >
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="后车车牌">{{
                  approvalDetailInfo.trailerPlate
                    ? approvalDetailInfo.trailerPlate
                    : "暂无"
                }}</el-form-item></el-col
              >
              <el-col :span="12">
                <el-form-item label="车长">{{
                  approvalDetailInfo.vehicleLong
                    ? approvalDetailInfo.vehicleLong
                    : "暂无"
                }}</el-form-item></el-col
              >
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="公司名称">{{
                  approvalDetailInfo.companyName
                    ? approvalDetailInfo.companyName
                    : "暂无"
                }}</el-form-item></el-col
              >
              <el-col :span="12">
                <el-form-item label="园区">{{
                  approvalDetailInfo.appointmentParkName
                    ? approvalDetailInfo.appointmentParkName
                    : "暂无"
                }}</el-form-item></el-col
              >
            </el-row>
            <el-row>
              <el-col :span="12" class="basic-status-box">
                <el-form-item label="状态"
                  ><div>
                    {{
                      approvalDetailInfo.appointmentStatusName
                        ? approvalDetailInfo.appointmentStatusName
                        : "暂无"
                    }}
                  </div></el-form-item
                ></el-col
              >
              <el-col :span="12">
                <el-form-item label="数据来源">{{
                  approvalDetailInfo.dataSource
                    ? approvalDetailInfo.dataSource == "1"
                      ? "客服录入"
                      : approvalDetailInfo.dataSource == "0"
                      ? "司机预约"
                      : "暂无"
                    : "暂无"
                }}</el-form-item></el-col
              >
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="是否特殊商品">{{
                  approvalDetailInfo.specialProductFlag
                    ? approvalDetailInfo.specialProductFlag == 1
                      ? "是"
                      : approvalDetailInfo.specialProductFlag == 0
                      ? "否"
                      : "暂无"
                    : "暂无"
                }}</el-form-item></el-col
              >
              <el-col :span="12">
                <el-form-item label="是否暂停作业">{{
                  approvalDetailInfo.isPauseWork
                    ? approvalDetailInfo.isPauseWork == 1
                      ? "是"
                      : approvalDetailInfo.isPauseWork == 0
                      ? "否"
                      : "暂无"
                    : "暂无"
                }}</el-form-item></el-col
              >
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="回退原因">{{
                  approvalDetailInfo.fallbackReason
                    ? approvalDetailInfo.fallbackReason
                    : "暂无"
                }}</el-form-item></el-col
              >
              <el-col :span="12">
                <el-form-item label="作业类型">{{
                  approvalDetailInfo.operateType
                    ? approvalDetailInfo.operateType == "1"
                      ? "装货"
                      : approvalDetailInfo.operateType == "2"
                      ? "卸货"
                      : approvalDetailInfo.operateType == "3"
                      ? "过车"
                      : "暂无"
                    : "暂无"
                }}</el-form-item></el-col
              >
            </el-row>
            <el-row v-if="approvalDetailInfo.operateType == '3'">
              <el-col :span="12">
                <el-form-item label="操作类型">{{
                  approvalDetailInfo.passType
                    ? approvalDetailInfo.passType == "1"
                      ? "倒入"
                      : approvalDetailInfo.passType == "2"
                      ? "倒出"
                      : "暂无"
                    : "未识别"
                }}</el-form-item></el-col
              >
            </el-row>
          </el-form>
        </el-card>
        <!-- 货物信息 -->
        <h3>货物信息</h3>
        <el-card style="margin: 15px 20px 15px 10px">
          <el-table
            border
            :data="cabinetData"
            style="overflow-y: auto; max-height: 300px"
          >
            <el-table-column label="序号" width="80">
              <template slot-scope="scope">
                {{ scope.$index + 1 }}
              </template>
            </el-table-column>
            <el-table-column
              prop="waresName"
              label="货物名称"
            ></el-table-column>
            <el-table-column prop="waresCount" label="数量"></el-table-column>
            <el-table-column
              prop="cabinetNumber"
              label="柜号"
            ></el-table-column>
            <template slot="empty"><dataEmpty /></template>
          </el-table>
        </el-card>
        <!-- 入园信息 -->
        <h3>入园信息</h3>
        <el-card style="margin: 15px 20px 15px 10px">
          <el-form
            :inline="true"
            :model="approvalDetailInfo"
            label-width="110px"
            label-position="right"
            label-suffix=" :"
          >
            <el-row>
              <el-col :span="12">
                <el-form-item label="申请时间">{{
                  approvalDetailInfo.createTime
                    ? approvalDetailInfo.createTime
                    : "暂无"
                }}</el-form-item></el-col
              >
              <el-col :span="12">
                <el-form-item label="预计到达时间">{{
                  approvalDetailInfo.estimatedArrivalTime
                    ? approvalDetailInfo.estimatedArrivalTime
                    : "暂无"
                }}</el-form-item>
              </el-col>
            </el-row>
            <el-row v-if="inParkObj.createTime || inParkObj.createName">
              <el-col :span="12">
                <el-form-item label="调度">
                  {{ inParkObj.createName ? inParkObj.createName : "暂无" }}
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="调度入园审批时间">{{
                  inParkObj.createTime ? inParkObj.createTime : "暂无"
                }}</el-form-item>
              </el-col>
            </el-row>
            <el-row class="img-info-box">
              <el-col :span="12">
                <el-form-item label="驾驶证">
                  <div>
                    <img
                      style="
                        width: 150px;
                        height: 150px;
                        cursor: pointer;
                        position: absolute;
                      "
                      onerror="this.src='/images/theme/newDark/default.png'"
                      :src="getImgPath(approvalDetailInfo.driverLicense)"
                      @click="showViewer(approvalDetailInfo.driverLicense)"
                    />
                  </div>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="行驶证">
                  <div>
                    <img
                      style="
                        width: 150px;
                        height: 150px;
                        cursor: pointer;
                        position: absolute;
                      "
                      onerror="this.src='/images/theme/newDark/default.png'"
                      :src="getImgPath(approvalDetailInfo.drivingLicense)"
                      @click="showViewer(approvalDetailInfo.drivingLicense)"
                    />
                  </div>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row class="img-info-box">
              <el-col :span="12">
                <el-form-item label="前车车牌照片">
                  <div>
                    <img
                      style="
                        width: 150px;
                        height: 150px;
                        cursor: pointer;
                        position: absolute;
                      "
                      onerror="this.src='/images/theme/newDark/default.png'"
                      :src="
                        getImgPath(
                          approvalDetailInfo &&
                            approvalDetailInfo.frontLicensePlatePicture
                        )
                      "
                      @click="
                        showViewer(
                          approvalDetailInfo &&
                            approvalDetailInfo.frontLicensePlatePicture
                        )
                      "
                    />
                  </div>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="挂车牌照片">
                  <div>
                    <img
                      style="
                        width: 150px;
                        height: 150px;
                        cursor: pointer;
                        position: absolute;
                      "
                      onerror="this.src='/images/theme/newDark/default.png'"
                      :src="
                        getImgPath(
                          approvalDetailInfo &&
                            approvalDetailInfo.trailerLicensePlatePicture
                        )
                      "
                      @click="
                        showViewer(
                          approvalDetailInfo &&
                            approvalDetailInfo.trailerLicensePlatePicture
                        )
                      "
                    />
                  </div>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </el-card>
        <!-- 作业信息 -->
        <h3
          v-if="
            (approvalDetailInfo.appointmentStatus >= 6 &&
              approvalDetailInfo.appointmentStatus <= 10) ||
            approvalDetailInfo.appointmentStatus == 99
          "
        >
          作业信息
        </h3>
        <el-card
          v-if="
            (approvalDetailInfo.appointmentStatus >= 6 &&
              approvalDetailInfo.appointmentStatus <= 10) ||
            approvalDetailInfo.appointmentStatus == 99
          "
          style="margin: 15px 20px 15px 10px"
        >
          <el-table
            stripe
            :data="cabinetData"
            style="overflow-y: auto; margin: 0 auto; max-height: 300px"
          >
            <el-table-column label="序号" width="80">
              <template slot-scope="scope">
                {{ scope.$index + 1 }}
              </template>
            </el-table-column>
            <el-table-column
              prop="waresName"
              label="货物名称"
              width="100"
            ></el-table-column>
            <el-table-column
              prop="waresCount"
              label="数量"
              width="100"
            ></el-table-column>
            <el-table-column
              prop="cabinetNumber"
              label="柜号"
              width="150"
            ></el-table-column>
            <el-table-column
              prop="platformName"
              label="月台"
              width="150"
            ></el-table-column>
            <el-table-column
              prop="operatorName"
              label="库管"
              width="100"
            ></el-table-column>
            <el-table-column
              prop="status"
              label="状态"
              width="100"
            ></el-table-column>
            <el-table-column
              prop="startWorkTime"
              label="开始时间"
              width="180"
            ></el-table-column>
            <el-table-column
              prop="finishWorkTime"
              label="结束时间"
              width="180"
            ></el-table-column>
            <el-table-column prop="workImg" label="作业图片" width="100">
              <template slot-scope="scope">
                <img
                  style="
                    width: 20px;
                    height: 20px;
                    cursor: pointer;
                    position: absolute;
                    left: 30%;
                    top: 20%;
                  "
                  onerror="this.src='/images/theme/newDark/default.png'"
                  :src="getImgPath(scope.row.workImg)"
                  @click="showViewer(scope.row.workImg)"
                />
              </template>
            </el-table-column>
            <template slot="empty"><dataEmpty /></template>
          </el-table>
        </el-card>
        <!-- 出园信息 -->
        <h3
          v-if="
            (approvalDetailInfo.appointmentStatus >= 8 &&
              approvalDetailInfo.appointmentStatus <= 10) ||
            approvalDetailInfo.appointmentStatus == 99
          "
        >
          出园信息
        </h3>
        <el-card
          v-if="
            (approvalDetailInfo.appointmentStatus >= 8 &&
              approvalDetailInfo.appointmentStatus <= 10) ||
            approvalDetailInfo.appointmentStatus == 99
          "
          style="margin: 15px 20px 15px 10px"
        >
          <el-form
            :inline="true"
            :model="exitParkObj"
            label-width="110px"
            label-position="right"
            label-suffix=" :"
          >
            <el-row v-if="approvalDetailInfo.appointmentStatus >= 8">
              <el-col :span="12">
                <el-form-item label="客服">
                  {{
                    exitParkObj.customerService
                      ? exitParkObj.customerService
                      : "暂无"
                  }}
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="客服审批时间">
                  {{
                    exitParkObj.customerServiceTime
                      ? exitParkObj.customerServiceTime
                      : "暂无"
                  }}
                </el-form-item>
              </el-col>
            </el-row>
            <el-row v-if="approvalDetailInfo.appointmentStatus >= 9">
              <el-col :span="12">
                <el-form-item label="调度">
                  {{ exitParkObj.dispatch ? exitParkObj.dispatch : "暂无" }}
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="调度审批时间">
                  {{
                    exitParkObj.dispatchTime ? exitParkObj.dispatchTime : "暂无"
                  }}
                </el-form-item>
              </el-col>
            </el-row>
            <el-row v-if="approvalDetailInfo.appointmentStatus >= 10">
              <el-col :span="12">
                <el-form-item label="门卫">
                  {{ exitParkObj.doorman ? exitParkObj.doorman : "暂无" }}
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="门卫放行时间">
                  {{
                    exitParkObj.doormanTime ? exitParkObj.doormanTime : "暂无"
                  }}
                </el-form-item>
              </el-col>
            </el-row>
            <el-row
              class="img-info-box"
              v-if="approvalDetailInfo.appointmentStatus >= 10"
            >
              <el-col :span="12">
                <el-form-item label="门卫放行拍照">
                  <div>
                    <img
                      style="
                        width: 150px;
                        height: 150px;
                        cursor: pointer;
                        position: absolute;
                      "
                      onerror="this.src='/images/theme/newDark/default.png'"
                      :src="getImgPath(exitParkObj && exitParkObj.doormanPic)"
                      @click="showViewer(exitParkObj && exitParkObj.doormanPic)"
                    />
                  </div>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </el-card>

        <!-- 流程节点 -->
        <h3>流程节点</h3>
        <div style="width: 100%; margin-top: 20px">
          <el-card style="margin: 15px 20px 15px 10px">
            <processNode :nodeArr="nodeArr"></processNode>
          </el-card>
        </div>
      </div>
      <div slot="footer">
        <el-button @click="handleClosePanel">关闭</el-button>
      </div>
    </appPanel>
    <!-- 审批--是否是特殊商品--弹窗 -->
    <el-dialog
      title="审核通过确认"
      :append-to-body="true"
      :visible.sync="dialogPassReview"
      width="60vw"
      class="choose-container"
      @close="cancelPassReview"
    >
      <div style="height: 10vh">
        <el-form
          :inline="true"
          ref="refPassForm"
          label-position="right"
          label-width="140px"
          :model="passForm"
          :rules="passRule"
        >
          <el-form-item label="是否是特殊商品" prop="specialProductFlag">
            <el-radio-group
              v-model="passForm.specialProductFlag"
              style="width: 42vw"
            >
              <el-radio :label="'1'">是</el-radio>
              <el-radio :label="'0'">否</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="info" @click="cancelPassReview">取消</el-button>
        <el-button type="primary" @click="confirmPassReview">确定</el-button>
      </div>
    </el-dialog>
    <!-- 拒绝弹窗 -->
    <el-dialog
      title="拒绝审核确认"
      :append-to-body="true"
      :visible.sync="dialogRejectReview"
      width="60vw"
      class="choose-container"
      @close="cancelRejectReview"
    >
      <div style="height: 10vh">
        <el-form
          :inline="true"
          ref="refRejectForm"
          label-position="right"
          label-width="90px"
          :model="rejectForm"
          :rules="rejectRule"
        >
          <el-form-item label="拒绝原因" prop="remark">
            <el-input
              v-model="rejectForm.remark"
              type="textarea"
              :rows="2"
              placeholder="请输入拒绝原因"
              style="width: 48vw"
            />
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="info" @click="cancelRejectReview">取消</el-button>
        <el-button type="primary" @click="confirmRejectReview">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { api } from "../api/index";
import appPanel from "@src/components/business/app-panel/index.vue";
import dataEmpty from "@src/components/common/ioc-component/app-data-empty.vue";
import processNode from "@src/modules/processMonitor/components/ProcessNode.vue";
import { Bus, Dates } from "$utils";
import utils from "@src/common/utils";
import { tableOption } from "../config/appointApprovalTable";

export default {
  components: {
    appPanel,
    dataEmpty,
    processNode,
  },
  data() {
    return {
      form: {},
      showPanel: false,
      unApprovalTableOption: tableOption(),
      approvalDoneTableOption: tableOption(),
      // 未审核 分页属性设置
      unApprovalPage: {
        currentPage: 1,
        total: 10,
        pageSize: utils.Cache.get("CURRENT_PAGESIZE") || 10,
      },
      unApprovalTableData: [],
      // 已审核 分页属性设置
      approvalDonePage: {
        currentPage: 1,
        total: 10,
        pageSize: utils.Cache.get("CURRENT_PAGESIZE") || 10,
      },
      approvalDoneTableData: [],
      // 选择的carId
      checkedCarIds: [],
      // 选择的预约审批Id
      checkedAppointmentUuid: [],
      // 查询条件
      appointmentStatusList: [
        {
          label: "未审核",
          value: 1,
        },
        {
          label: "已审核",
          value: 2,
        },
        // {
        //   label: "已签到",
        //   value: 3,
        // },
        // {
        //   label: "未通过",
        //   value: 4,
        // },
        // {
        //   label: "已调度",
        //   value: 5,
        // },
      ],
      // 选择的作业类型
      selectedType: [],
      zyTypeOptions: [
        {
          label: "装货",
          value: "1",
        },
        {
          label: "卸货",
          value: "2",
        },
        {
          label: "过车",
          value: "3",
        },
      ],
      // 选择的操作类型
      selectedOperateType: [],
      czTypeOptions: [
        {
          label: "倒入",
          value: "1",
        },
        {
          label: "倒出",
          value: "2",
        },
      ],
      dateRange: [],
      searchForm: {
        appointmentPark: null,
        startPlanArrivalTime: null,
        endPlanArrivalTime: null,
        driverName: null,
        frontPlate: null,
        workflowStatus: undefined,
        workStatus: "1",
        operateTypes: null, // 作业类型
        passTypes: null, // 操作类型
        cabinetNo: null,
        phone: null,
      },
      showExpandBtn: false,
      showSearch: true,
      // 下拉选项
      parkOptions: [
        {
          label: "天津优合进出口有限公司",
          value: "200000001",
        },
      ],
      // 审核状态
      activeStatusIndex: 0,
      selectStatusList: ["未审核", "已审核"],
      // 详情数据
      approvalDetailInfo: {},
      cabinetData: [],
      exitParkObj: {
        customerService: "",
        customerServiceTime: "",
        dispatch: "",
        dispatchTime: "",
        doorman: "",
        doormanTime: "",
        doormanPic: "",
      },
      // 入园信息
      inParkObj: {
        createName: "",
        createTime: "",
      },
      nodeArr: [],
      // 拒绝审核
      dialogRejectReview: false,
      rejectObj: {},
      rejectForm: {
        remark: "",
      },
      rejectRule: {
        remark: {
          required: true,
          message: "请输入拒绝原因",
          trigger: ["blur", "change"],
        },
      },
      // 审核通过
      dialogPassReview: false,
      passObj: {},
      passForm: {
        specialProductFlag: "",
      },
      passRule: {
        specialProductFlag: {
          required: true,
          message: "请选择是否是特殊商品",
          trigger: ["blur", "change"],
        },
      },
    };
  },
  mounted() {
    this.getUnApprovalList();
    this.animation();
  },
  beforeDestroy() {},
  methods: {
    getImgPath(item) {
      return item ? Bus.imgPath(item.split(",")[0]) : "";
    },
    showViewer(item) {
      console.log("-----------------", item);
      if (!item) return;
      console.log("----------2-------", item);
      this.$app.AppInstance.handleShowViewer(
        item.split(",").map((o) => this.getImgPath(o))
      );
    },
    animation() {
      let that = this;
      let domAry =
        document.querySelector(".searchContent") &&
        document.querySelector(".searchContent").children;
      console.log("--谷峰平--domAry:-", domAry);
      if (!domAry) {
        return;
      }
      window.onresize = function () {
        that.animation();
      };
      if (domAry[domAry.length - 1].offsetTop != domAry[0].offsetTop) {
        console.log("--00--");
        this.showExpandBtn = true;
      } else {
        console.log("--111--");
        this.showExpandBtn = false;
      }
    },
    showNameByStatus(pStatus) {
      if (pStatus == "0") {
        return "已申请";
      } else if (pStatus == "1") {
        return "待审批";
      } else if (pStatus == "2") {
        return "已通过";
      } else if (pStatus == "3") {
        return "待签到";
      } else if (pStatus == "4") {
        return "已签到";
      } else if (pStatus == "5") {
        return "待调度";
      } else if (pStatus == "6") {
        return "已调度";
      } else if (pStatus == "7") {
        return "待作业";
      } else if (pStatus == "8") {
        return "作业中";
      } else if (pStatus == "9") {
        return "已完成作业";
      } else if (pStatus == "10") {
        return "待客服押车不放行";
      } else if (pStatus == "17") {
        return "客服已押车不放行";
      } else if (pStatus == "18") {
        return "客服不押车已放行";
      } else if (pStatus == "19") {
        return "客服已解压车";
      } else if (pStatus == "20") {
        return "客服待解压车";
      } else if (pStatus == "26") {
        return "待客服不押车放行";
      } else if (pStatus == "27") {
        return "待调度不押车放行";
      } else if (pStatus == "11") {
        return "客服出园待审批";
      } else if (pStatus == "12") {
        return "客服出园审批已完成";
      } else if (pStatus == "13") {
        return "调度出园待审批";
      } else if (pStatus == "14") {
        return "调度出园审批已完成";
      } else if (pStatus == "15") {
        return "待出园";
      } else if (pStatus == "16") {
        return "已出园";
      } else if (pStatus == "21") {
        return "待调度押车不放行";
      } else if (pStatus == "22") {
        return "调度已押车不放行";
      } else if (pStatus == "23") {
        return "调度不押车已放行";
      } else if (pStatus == "24") {
        return "调度待解压车";
      } else if (pStatus == "25") {
        return "调度已解压车";
      } else if (pStatus == "96") {
        return "已取消";
      } else if (pStatus == "97") {
        return "已拒绝";
      } else if (pStatus == "98") {
        return "已作废";
      } else if (pStatus == "99") {
        return "结束";
      } else if (pStatus == "95") {
        return "异常终止";
      } else {
        return "暂无";
      }
    },
    handleStatusTabClick(index) {
      this.activeStatusIndex = index;
      if (this.activeStatusIndex == 0) {
        this.searchForm.workflowStatus = undefined;
        this.searchForm.workStatus = "1";
        this.getUnApprovalList();
      } else {
        this.searchForm.workStatus = undefined;
        this.searchForm.workflowStatus = "2,97";
        this.getApprovalDoneList();
      }
    },
    // 获取未审核列表数据
    getUnApprovalList() {
      if (this.dateRange && this.dateRange.length > 0) {
        this.searchForm.startPlanArrivalTime = this.dateRange[0];
        this.searchForm.endPlanArrivalTime = this.dateRange[1];
      } else {
        this.searchForm.startPlanArrivalTime = null;
        this.searchForm.endPlanArrivalTime = null;
      }
      // 作业类型 operateTypes
      if (!this.selectedType.includes("3")) {
        this.searchForm.passTypes = null;
        this.searchForm.operateTypes = this.selectedType.join(",");
      } else {
        this.searchForm.operateTypes = this.selectedType.join(",");
      }
      // 操作类型
      this.searchForm.passTypes = this.selectedOperateType.join(",");
      const param = {
        ...this.searchForm,
        pageNumber: this.unApprovalPage.currentPage,
        pageSize: this.unApprovalPage.pageSize,
      };
      this.$fetch(api.appointApproval.queryAppointApprovalList, param).then(
        (res) => {
          if (res.success) {
            this.unApprovalTableData = res.returnObj.list;
            this.unApprovalPage.total = res.returnObj.total;
          }
        }
      );
    },
    // 获取已审核列表数据
    getApprovalDoneList() {
      if (this.dateRange && this.dateRange.length > 0) {
        this.searchForm.startPlanArrivalTime = this.dateRange[0];
        this.searchForm.endPlanArrivalTime = this.dateRange[1];
      } else {
        this.searchForm.startPlanArrivalTime = null;
        this.searchForm.endPlanArrivalTime = null;
      }
      // 作业类型 operateTypes
      if (!this.selectedType.includes("3")) {
        this.searchForm.passTypes = null;
        this.searchForm.operateTypes = this.selectedType.join(",");
      } else {
        this.searchForm.operateTypes = this.selectedType.join(",");
      }
      // 操作类型
      this.searchForm.passTypes = this.selectedOperateType.join(",");

      const param = {
        ...this.searchForm,
        pageNumber: this.approvalDonePage.currentPage,
        pageSize: this.approvalDonePage.pageSize,
      };
      this.$fetch(api.appointApproval.queryAppointApprovalList, param).then(
        (res) => {
          if (res.success) {
            this.approvalDoneTableData = res.returnObj.list;
            this.approvalDonePage.total = res.returnObj.total;
          }
        }
      );
    },
    handleView(row, index) {
      this.showPanel = true;
      console.log("--车辆详情--row:--", row);
      this.approvalDetailInfo = row;
      // this.cabinetData = row.cabinets;
      // 货物信息
      let cabinets = row.cabinets;
      if (cabinets.length > 0) {
        this.cabinetData = cabinets.map((item) => {
          let newItem = {
            ...item,
            operatorName: "",
            platformId: "",
            status: "",
          };
          if (item.workflows.length > 0) {
            newItem.operatorName = item.workflows[0].operatorName;
            newItem.platformId = item.workflows[0].platformId;
            newItem.status =
              item.workflows[0].status == "7"
                ? "待作业"
                : item.workflows[0].status == "8"
                ? "作业中"
                : item.workflows[0].status == "9"
                ? "已完成"
                : item.workflows[0].status == ""
                ? "未分配"
                : "未分配";
          } else {
            newItem.operatorName = "";
            newItem.platformId = "";
            newItem.status = "";
          }
          return newItem;
        });
      } else {
        this.cabinetData = [];
      }
      // 流程节点信息
      let workflow = row.workflows;
      if (workflow.length > 0) {
        this.nodeArr = workflow.map((item) => {
          let newItem = {
            ...item,
            nodeWay:
              item.status == "0"
                ? "已申请"
                : item.status == "1"
                ? "待审批"
                : item.status == "2"
                ? "已通过"
                : item.status == "3"
                ? "待签到"
                : item.status == "4"
                ? "已签到"
                : item.status == "5"
                ? "待调度"
                : item.status == "6"
                ? "已调度"
                : item.status == "7"
                ? "待作业"
                : item.status == "8"
                ? "作业中"
                : item.status == "9"
                ? "已完成作业"
                : item.status == "10"
                ? "待客服押车不放行"
                : item.status == "17"
                ? "客服已押车不放行"
                : item.status == "18"
                ? "客服不押车已放行"
                : item.status == "19"
                ? "客服已解压车"
                : item.status == "20"
                ? "客服待解压车"
                : item.status == "26"
                ? "待客服不押车放行"
                : item.status == "27"
                ? "待调度不押车放行"
                : item.status == "11"
                ? "客服出园待审批"
                : item.status == "12"
                ? "客服出园审批已完成"
                : item.status == "13"
                ? "调度出园待审批"
                : item.status == "14"
                ? "调度出园审批已完成"
                : item.status == "15"
                ? "待出园"
                : item.status == "16"
                ? "已出园"
                : item.status == "21"
                ? "待调度押车不放行"
                : item.status == "22"
                ? "调度已押车不放行"
                : item.status == "23"
                ? "调度不押车已放行"
                : item.status == "24"
                ? "调度待解压车"
                : item.status == "25"
                ? "调度已解压车"
                : item.status == "96"
                ? "已取消"
                : item.status == "97"
                ? "已拒绝"
                : item.status == "98"
                ? "已作废"
                : item.status == "99"
                ? "结束"
                : item.status == "95"
                ? "异常终止"
                : "暂无",
            nodeName: item.operatorName ? item.operatorName : "暂无",
            nodeDate: item.operateTime ? item.operateTime : "暂无",
          };
          return newItem;
        });
      } else {
        this.nodeArr = [];
      }
      // 出园信息
      let exitParkArr = row.workflows;
      if (exitParkArr.length > 0) {
        exitParkArr.forEach((wfItem) => {
          if (wfItem.status == "12") {
            this.exitParkObj.customerService = wfItem.operatorName;
            this.exitParkObj.customerServiceTime = wfItem.operateTime;
          }
          if (wfItem.status == "14") {
            this.exitParkObj.dispatch = wfItem.operatorName;
            this.exitParkObj.dispatchTime = wfItem.operateTime;
          }
          if (wfItem.status == "16") {
            this.exitParkObj.doorman = wfItem.operatorName;
            this.exitParkObj.doormanTime = wfItem.operateTime;
            this.exitParkObj.doormanPic = wfItem.fileCode;
          }
        });
      } else {
        this.exitParkObj.customerService = "";
        this.exitParkObj.customerServiceTime = "";
        this.exitParkObj.dispatch = "";
        this.exitParkObj.dispatchTime = "";
        this.exitParkObj.doorman = "";
        this.exitParkObj.doormanTime = "";
        this.exitParkObj.doormanPic = "";
      }
      // 入园信息
      let inParkArr = row.workflows;
      if (inParkArr.length > 0) {
        inParkArr.forEach((ipItem) => {
          if (ipItem.status == "2") {
            this.inParkObj.createName = ipItem.operatorName;
            this.inParkObj.createTime = ipItem.operateTime;
          }
        });
      } else {
        this.inParkObj.createTime = "";
        this.inParkObj.createName = "";
      }
      console.log("-this.inParkObj:-", this.inParkObj);
    },
    //关闭详情
    handleClosePanel() {
      this.showPanel = false;
    },

    closeDialog() {},

    handleSelectionChange(items) {
      console.log("---select--items:--", items);

      if (!items || !items.length) {
        this.checkedCarIds = [];
      } else {
        this.checkedCarIds = items.map((item) => {
          return {
            appointmentId: item.appointmentId,
            serialNumber: item.serialNumber,
          };
        });
      }
      console.log("----this.checkedCarIds:---", this.checkedCarIds);
    },

    // 查询按钮事件
    searchResult() {
      console.log("---查询--this.searchForm:--", this.searchForm);
      if (this.activeStatusIndex == 0) {
        this.unApprovalPage.currentPage = 1;
        this.getUnApprovalList();
      } else {
        this.approvalDonePage.currentPage = 1;
        this.getApprovalDoneList();
      }
    },
    // 重置按钮
    resetQuery() {
      this.dateRange = [];
      this.selectedType = [];
      this.selectedOperateType = [];
      this.searchForm = {
        appointmentPark: null,
        startPlanArrivalTime: null,
        endPlanArrivalTime: null,
        driverName: null,
        frontPlate: null,
        workflowStatus: undefined,
        workStatus: "1",
        operateTypes: null, // 作业类型
        passTypes: null, // 操作类型
        cabinetNo: null,
        phone: null,
      };
      if (this.activeStatusIndex == 0) {
        this.searchForm.workflowStatus = undefined;
        this.searchForm.workStatus = "1";
        console.log("-unApproval-workStatus:-", this.searchForm.workStatus);
        this.getUnApprovalList();
      } else {
        this.searchForm.workStatus = undefined;
        this.searchForm.workflowStatus = "2,97";
        console.log("-approval-workStatus:-", this.searchForm.workStatus);
        this.getApprovalDoneList();
      }
    },
    // 未审批 点击上一页下一页按钮
    selectUnApprovalPage(val) {
      this.unApprovalPage.currentPage = val;
      this.getUnApprovalList();
    },
    // 未审批 修改每页数据数量
    changeUnApprovalSize(val) {
      this.unApprovalPage.currentPage = 1;
      this.unApprovalPage.pageSize = val;
      this.getUnApprovalList();
    },
    // 已审批 点击上一页下一页按钮
    selectApprovalDonePage(val) {
      this.approvalDonePage.currentPage = val;
      this.getApprovalDoneList();
    },
    // 已审批 修改每页数据数量
    changeApprovalDoneSize(val) {
      this.approvalDonePage.currentPage = 1;
      this.approvalDonePage.pageSize = val;
      this.getApprovalDoneList();
    },
    // 处理单个审核通过操作
    handelPassSingleAppoint(row) {
      this.dialogPassReview = true;
      this.passObj = row;
    },
    // 校验系统中是否存在该商品
    checkIsExistedAppointment() {
      this.$fetch(
        api.appointApproval.isExistedAppointment + this.passObj.appointmentUuid
      ).then((response) => {
        if (response && response.success) {
          if (response.returnObj.exist) {
            this.$message({
              message: "系统存在相同司机姓名、电话、货品、柜号预约记录单! ",
              type: "warning",
              duration: 2000,
            });
          }
        } else {
          this.$message({
            message: response.msgContent,
            type: "error",
            duration: 2000,
          });
        }
        this.cancelPassReview();
        this.getUnApprovalList();
      });
    },
    // 取消审核通过
    cancelPassReview() {
      this.passForm.specialProductFlag = "";
      this.$nextTick(() => {
        this.$refs["refPassForm"].clearValidate();
      });
      this.dialogPassReview = false;
    },
    // 确认审核通过
    confirmPassReview() {
      this.$refs.refPassForm.validate((res) => {
        if (res) {
          this.$fetch(api.appointApproval.approvalExamine, {
            appointmentUuid: this.passObj.appointmentUuid,
            status: 2,
            specialProductFlag: this.passForm.specialProductFlag,
          }).then((response) => {
            if (response && response.success) {
              this.$message({
                message: "通过成功",
                type: "success",
                duration: 2000,
              });
            } else {
              this.$message({
                message: response.msgContent,
                type: "error",
                duration: 2000,
              });
            }
            this.checkIsExistedAppointment();
          });
        } else {
          return false;
        }
      });
    },
    // 批量通过车辆信息
    handelPassCars() {
      this.$confirm("您确定批量通过所选择的车辆入园申请吗?", "通过确认", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$fetch(
          api.carEnterManage.passVehicleAppointment,
          this.checkedCarIds
        ).then((response) => {
          if (response && response.success) {
            this.$message({
              message: "通过成功",
              type: "success",
              duration: 2000,
            });
          } else {
            this.$message({
              message: response.msgContent,
              type: "error",
              duration: 2000,
            });
          }
          this.getUnApprovalList();
        });
      });
    },
    // 取消拒绝审核
    cancelRejectReview() {
      this.rejectForm.remark = "";
      this.$nextTick(() => {
        this.$refs["refRejectForm"].clearValidate();
      });
      this.dialogRejectReview = false;
    },
    // 确认拒绝审核
    confirmRejectReview() {
      this.$refs.refRejectForm.validate((res) => {
        if (res) {
          this.$fetch(api.appointApproval.approvalExamine, {
            appointmentUuid: this.rejectObj.appointmentUuid,
            status: 97,
            remark: this.rejectForm.remark,
          }).then((response) => {
            if (response && response.success) {
              this.$message({
                message: "拒绝成功",
                type: "success",
                duration: 2000,
              });
            } else {
              this.$message({
                message: response.msgContent,
                type: "error",
                duration: 2000,
              });
            }
            this.cancelRejectReview();
            this.getUnApprovalList();
          });
        } else {
          return false;
        }
      });
    },
    // 拒绝单个车辆信息
    handelRejectSingleAppoint(row) {
      this.dialogRejectReview = true;
      this.rejectObj = row;
    },
    // 批量拒绝车辆信息
    handelRejectCars() {
      this.$confirm("您确定批量拒绝所选择的车辆入园申请吗?", "拒绝确认", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$fetch(
          api.carEnterManage.refuseVehicleAppointment,
          this.checkedCarIds.map((v) => v.appointmentId)
        ).then((response) => {
          if (response && response.success) {
            this.$message({
              message: "拒绝成功",
              type: "success",
              duration: 2000,
            });
          } else {
            this.$message({
              message: response.msgContent,
              type: "error",
              duration: 2000,
            });
          }
          this.getUnApprovalList();
        });
      });
    },
    // 导出操作
    exportOpt() {
      this.$confirm("您确定批量导出所选择的车辆入园信息吗?", "导出确认", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        if (this.searchForm.dates && this.searchForm.dates.length > 0) {
          this.searchForm.startTime = this.searchForm.dates[0];
          this.searchForm.endTime = this.searchForm.dates[1];
        }
        const param = {
          ...this.searchForm,
          appointmentType: 1,
        };
        this.$fetchDownLoad(
          api.carEnterManage.exportVehicleAppointmentWorkList,
          param,
          {
            responseType: "arraybuffer",
          }
        ).then((response) => {
          if (response.data || response.success) {
            const content = response.data;
            const blob = new Blob([content], {
              type: "application/vnd.ms-excel",
            });
            const fileName =
              "车辆入园信息" +
              Dates.format(Date.now(), "yyyyMMddHHmmssms") +
              ".xlsx";
            if ("download" in document.createElement("a")) {
              // 非IE下载
              const elink = document.createElement("a");
              elink.download = fileName;
              elink.style.display = "none";
              elink.href = URL.createObjectURL(blob);
              document.body.appendChild(elink);
              elink.click();
              URL.revokeObjectURL(elink.href); // 释放URL 对象
              document.body.removeChild(elink);
            } else {
              // IE10+下载
              navigator.msSaveBlob(blob, fileName);
            }
          } else {
            this.$message.error("导出请求失败，请稍后重试");
          }
        });
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@src/common/assets/style/mixin";

.expand {
  width: calc(100% - 250px);
  height: auto;
}

.up {
  width: calc(100% - 250px);
  height: 41px;
  overflow: hidden;
}

.panel-content {
  .content-top {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }

  .info-item {
    margin: 15px 0px;
    // width: 50%;
  }

  .item-img {
    margin: 15px 0px;
  }

  .label {
    padding: 0 20px;
    width: 100px;
    text-align: center;
  }

  .img-info-box {
    margin-bottom: 120px;
    position: relative;

    ::v-deep .el-form-item--small.el-form-item {
      margin-bottom: 18px;
      display: flex;
      width: 100%;

      .el-form-item__content {
        flex: 1;
      }
    }
  }
  .detail-info {
    width: 100%;
    padding: 0 40px;
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    flex-wrap: wrap;
  }
  .basic-status-box {
    display: flex;
    flex-direction: row;
    ::v-deep .el-form-item--small.el-form-item {
      margin-bottom: 18px;
      display: flex;
      width: 100%;

      .el-form-item__content {
        flex: 1;
      }
    }
  }
}

.access-record-container {
  width: 100%;
  height: 100%;

  .query {
    display: flex;
    justify-content: space-between;
    align-items: center;
    @include set_theme_color(background-color, left-menu-bg-color);
    padding: 10px 16px 3px;
    margin-bottom: 15px;

    .el-form-item {
      display: inline-block;
      margin-right: 20px;
      margin-bottom: 8px !important;
      vertical-align: top;
    }
  }
  .appoint-approval-status-box {
    width: 100%;
    height: 40px;
    background: white;
    padding: 0 0 0 15px;
    display: flex;
    flex-direction: row;
    align-items: center;
    .approval-status-btn {
      width: 100px;
      height: 32px;
      display: flex;
      align-items: center;
      justify-content: center;
      // background: #d7e8ff;
      color: black;
      cursor: pointer;
      font-size: 14px;
      background: white;
    }
    .approval-status-btn:hover {
      width: 100px;
      height: 32px;
      font-size: 14px;
      color: white;
      background: #0d4c9e;
    }
    .active {
      width: 100px;
      height: 32px;
      font-size: 14px;
      color: white;
      background: #0d4c9e;
    }
  }
  .appoint-approval-content-box {
    width: 100%;
    height: 0;
    flex: 1;
    /deep/ .ioc-table {
      width: 100%;
    }
    /deep/ .el-table__body-wrapper {
      width: 100%;
      height: calc(100% - 60px);
      max-height: calc(100% - 60px);
      overflow-y: auto;
    }
  }
  /deep/ .app-side-panel__body {
    overflow-y: auto;
  }
  .el-table__fixed-right-patch {
    display: none;
  }

  .el-dialog {
    .el-date-editor.el-input,
    .el-date-editor.el-input__inner {
      width: 260px;
    }
  }
}

.car-info-box {
  margin-bottom: 148px;
  position: relative;

  ::v-deep .el-form-item--small.el-form-item {
    margin-bottom: 18px;
    display: flex;
    width: 100%;

    .el-form-item__content {
      flex: 1;
    }
  }
}
</style>
